import type { BalanceType, UserInfoType } from '../../../api/fetchers/userInfo/types';
import type { CoreRootState } from '../../CoreStore';
import { betsOpenStatuses } from '../bets/betsOpenStatuses';

import type {
  CurrencyInfo,
  DealerType,
  TableCloseNotifyType,
  TableType,
  WinnersTotal,
  WinnerType,
  WinResultType,
  GameStatus,
} from './types';

export const selectHideUI = ({ gameState }: CoreRootState): boolean => gameState.hideUI;
export const selectWinners = ({ gameState }: CoreRootState): WinnerType[] => gameState.winners;
export const selectWinnersTotal = ({ gameState }: CoreRootState): WinnersTotal | null => gameState.winnersTotal;
export const selectWinResult = ({ gameState }: CoreRootState): WinResultType | null => gameState.winResult;
export const selectCurrentStatus = ({ gameState }: CoreRootState): GameStatus | string => gameState.currentStatus;
export const selectTimer = ({ gameState }: CoreRootState): number => gameState.timer;
export const selectTimerStartTime = ({ gameState }: CoreRootState): number => gameState.timerStartTime;
export const selectGameId = ({ gameState }: CoreRootState): string | null => gameState.gameId;
export const selectGameChannel = ({ gameState }: CoreRootState): string | null => gameState.gameChannel;
export const selectGameName = ({ gameState }: CoreRootState): string | null => gameState.gameName;
export const selectGameSubscribed = ({ gameState }: CoreRootState): boolean => !!gameState.gameChannel;
export const selectUserInfoReady = ({ gameState }: CoreRootState): boolean => !!gameState.userInfo;
export const selectUserInfo = ({ gameState }: CoreRootState): UserInfoType | null => gameState.userInfo;
export const selectUserScreenName = ({ gameState }: CoreRootState): string | undefined =>
  gameState.userInfo?.screenName;
export const selectUserBalance = ({ gameState }: CoreRootState): BalanceType | undefined => gameState.userInfo?.balance;
export const selectDeductibleBalance = ({ gameState }: CoreRootState): number =>
  (gameState.userInfo?.balance.amount ?? 0) + (gameState.userInfo?.balance.bonus ?? 0);
export const selectCurrency = ({ gameState }: CoreRootState): string | null => gameState.currency;
export const selectNetPosition = ({ gameState }: CoreRootState): number => gameState.netPosition;
export const selectCurrencyInfo = ({ gameState }: CoreRootState): CurrencyInfo | null => gameState.currencyInfo;
export const selectLeftDrawerOpened = ({ gameState }: CoreRootState): string | null => gameState.leftDrawerOpened;
export const selectDealer = ({ gameState }: CoreRootState): DealerType | null => gameState.dealer;
export const selectGameTable = ({ gameState }: CoreRootState): TableType | null => gameState.table;
export const selectIsGamePaused = ({ gameState }: CoreRootState): boolean => gameState.gamePaused;
export const selectIsGameAbandoned = ({ gameState }: CoreRootState): boolean => gameState.gameAbandoned;
export const selectIsGameSuspended = ({ gameState }: CoreRootState): boolean => gameState.gameSuspended;
export const selectIsLoadedInActiveRound = ({ gameState }: CoreRootState): boolean => gameState.isLoadedInActiveRound;
export const selectVideoPoster = ({ gameState }: CoreRootState): string => gameState.videoPoster;
export const selectTableCloseNotify = ({ gameState }: CoreRootState): TableCloseNotifyType | null =>
  gameState.tableCloseNotify;
export const selectCurrencyDecimals = ({ gameState }: CoreRootState): number =>
  gameState.currencyInfo?.digitsNumber ?? 2;
export const selectIsBetsOpen = ({ gameState }: CoreRootState): boolean =>
  betsOpenStatuses.includes(gameState.currentStatus);
